<template>
<v-dialog v-model="isVisible" scrollable max-width="700px">
    <v-card class="pa-2">
        <v-card-title>
            <b>
                거래 내역
            </b>
        </v-card-title>

        <v-divider />

        <v-card-text style="max-height: 500px">
            <div class="my-2" v-for="item in transactions" :key="item.createdAt">
                <v-divider />
                <v-row class="ma-0 pt-1">
                    <b :style="{color: sortColor(item.sort)}">{{ item.sort == 'buy'? '매수':'매도' }} / {{ item.name }} ({{ item.code }})</b>
                    <v-spacer />
                    <span>{{ item.date }}</span>
                </v-row>
                <v-row class="ma-0">
                    <v-col class="pa-0 text-center">
                        <span class="item-head">·거래금액</span>
                        <v-spacer />
                        <span>{{ commaFormat(item.total) }} 원</span>
                    </v-col>
                    <v-col class="pa-0 text-center">
                        <span class="item-head">·거래수량</span>
                        <v-spacer />
                        <span>{{ commaFormat(item.count) }} 주</span>
                    </v-col>
                    <v-col class="pa-0 text-center">
                        <span class="item-head">·거래단가</span>
                        <v-spacer />
                        <span>{{ commaFormat(item.price) }} 원</span>
                    </v-col>
                </v-row>
                <v-divider />
            </div>
        </v-card-text>

        <div class="text-center" style="cursor: pointer" v-if="!isLoading && !isEnd" @click="moreTransactions">더 보기</div>

        <v-row class="ma-0 py-2" justify="center">
            <v-progress-circular size="24" indeterminate color="primary" v-if="isLoading" />
        </v-row>

        <v-card-actions>
            <v-btn color="primary" @click="download">다운로드</v-btn>
            <v-spacer />
            <v-btn color="red" @click="close">닫 기</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import XLSX from 'xlsx'

export default {
    name: 'transaction-dialog',
    data() {
        return {
            isVisible: false,
            isLoading: false,
            isEnd: false,
            docRef: '',
            transactions: [],
        }
    },
    computed: {},
    methods: {
        async show(docRef) {
            this.isVisible = true
            this.docRef = docRef

            this.isLoading = true
            this.transactions = await docRef.collection('records').orderBy('createdAt', 'desc').limit(10).parseCollection()
            this.isLoading = false
        },
        async moreTransactions() {
            const newData = await this.docRef.collection('records')
                .orderBy('createdAt', 'desc')
                .startAfter(this.transactions[this.transactions.length - 1].createdAt)
                .limit(10)
                .parseCollection()

            if (newData.length == 0) return this.isEnd = true

            for (const data of newData) {
                this.transactions.push(data)
            }
        },
        download() {
            const wb = XLSX.utils.book_new()
            const abstractWS = XLSX.utils.json_to_sheet(this.transactions.map(v => {
                const {
                    id,
                    createdAt,
                    ...rest
                } = v
                return rest
            }), {
                header: ['date', 'sort', 'code', 'name', 'price', 'count', 'total']
            })
            XLSX.utils.book_append_sheet(wb, abstractWS, '거래내역')
            XLSX.writeFile(wb, '거래내역.xlsx')
        },
        close() {
            this.transactions = []
            this.isEnd = false
            this.isVisible = false
        },
        sortColor(sort) {
            return sort == 'buy' ? 'red' : 'blue'
        },
        commaFormat(value) {
            if (!value) return 0
            return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
    }
}
</script>

<style>
.item-head {
    font-size: 12px;
    font-weight: bold;
}
</style>